import { Component, OnInit, OnDestroy, PLATFORM_ID, Inject, output, EventEmitter, Output, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ClientService } from '../../services/client-service';

interface TripResponse {
  success: boolean;
  message: string;
  activeTrip: boolean;
  activeTripId: string;
  ticket: {
    tripType: number;
    tripMode: number;
    initialAddress: string;
    destinationAddress: string;
    fare: number;
    status: number;
    driverId: string;
    driverFullName: string;
    driverPhoneNumber: string;
    driverPhoneCountry: string;
    driverCarModel: string;
    driverCarPlateNumber: string;
    taxiNum: number;
    scheduledDatetime: string;
    tripRequestTime: string;
    ref: string;
    ticketId: string;
  };
}

@Component({
  selector: 'app-show-ticket',
  templateUrl: './show-ticket.component.html',
  styleUrls: ['./show-ticket.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  
  imports: [CommonModule, RouterModule, TranslateModule]
})
export class ShowTicketComponent implements OnInit, OnDestroy {
  activeTrip: TripResponse | null = null;
  private refreshInterval: any;
  ticketId: string | null = null;
  @Output() showTicket: EventEmitter<{ ticketId: string}> = new EventEmitter<{ ticketId: string }>();

  constructor(
    private clientService: ClientService,
        private _changeDetectorRef: ChangeDetectorRef,
    
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  ngOnInit(): void {
    
    if (this.platformId) {
      // Check immediately

      // alert('Checking current ticket...');
      this.checkCurrentTicket()

      
    }
  }

  ngOnDestroy(): void {
    // if (this.refreshInterval) {
    //   clearInterval(this.refreshInterval);
    // }
  }

  private checkCurrentTicket(): void {


    const ticketId = localStorage.getItem('currentTicketId');
    if (ticketId) {
      this.ticketId = ticketId;
    }

  }

  isScheduledTrip(): boolean {
    if (!this.activeTrip?.ticket) return false;
    const now = new Date();
    const scheduledTime = new Date(this.activeTrip.ticket.scheduledDatetime);
    return scheduledTime.getTime() > now.getTime();
  }



  isNowTrip(): boolean {
    if (!this.activeTrip?.ticket) return false;

    const now = new Date();
    const tripRequestTime = new Date(this.activeTrip.ticket.tripRequestTime);
    const scheduledTime = this.activeTrip.ticket.scheduledDatetime 
      ? new Date(this.activeTrip.ticket.scheduledDatetime)
      : null;

    if (scheduledTime) {
      const timeDiff = scheduledTime.getTime() - now.getTime();
      const thirtyMinutesInMs = 30 * 60 * 1000;
      return timeDiff <= thirtyMinutesInMs && timeDiff >= -thirtyMinutesInMs;
    }

    const oneHourInMs = 60 * 60 * 1000;
    return (now.getTime() - tripRequestTime.getTime()) <= oneHourInMs;
  }

  getTimeMessage(): string {
    if (!this.activeTrip?.ticket) return '';

    const scheduledTime = this.activeTrip.ticket.scheduledDatetime 
      ? new Date(this.activeTrip.ticket.scheduledDatetime)
      : null;

    if (scheduledTime) {
      const timeStr = scheduledTime.toLocaleTimeString('fr-FR', { 
        hour: '2-digit', 
        minute: '2-digit' 
      });
      const dateStr = scheduledTime.toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: '2-digit'
      });
      return `${timeStr} le ${dateStr}`;
    }
    return '';
  }

  dismiss(): void {

  }
  isHasDriver(): boolean {
    return this.activeTrip?.ticket?.driverId ? true : false;
  }

  showTicketAction(): void {

    if(this.ticketId) {
    this.showTicket.emit({ticketId: this.ticketId ??   '' });
    }


  }
}
